import gql from "graphql-tag";

export const BRAND_POSTS = gql`
  query ($after: String!, $before: String!, $filters: PostsFilter, $first: Int) {
    posts(sort: [CREATED_AT_DESC], before: $before, after: $after, filters: $filters, first: $first) {
      edges {
        node {
          media {
            id
            originalUrl
            croppedUrl
            cropParams
            productTags
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
